import React from 'react';

export interface Props {
  condition?: boolean;
  wrap?: (child: React.ReactNode) => React.ReactNode;
  elseWrap?: (child: React.ReactNode) => React.ReactNode;
}

export const ConditionalWrapper: React.FC<React.PropsWithChildren<Props>> = ({
  wrap,
  elseWrap,
  condition,
  children,
}) => (
  <>
    {condition && wrap
      ? wrap(children)
      : elseWrap
      ? elseWrap(children)
      : children}
  </>
);
ConditionalWrapper.displayName = 'ConditionalWrapper';

export default ConditionalWrapper;
